// https://github.com/ElMassimo/stimulus-vite-helpers
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

export const application = Application.start()
const controllers = import.meta.globEager('./**/*-controller.js')
registerControllers(application, controllers)
